import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LeadService } from '../../shared/services/lead.service';
@Component({
    moduleId: module.id,
    selector: 'lead-notication-detail',
    templateUrl: 'lead-notication-detail.html'
})

export class LeadNoticationDetailComponent implements OnInit {
    leadNoticationDetail: any;
    leadNoticationDetails: any = [];
    constructor(
        public activeModal: NgbActiveModal,
        public leadService: LeadService
    ) { }
    ngOnInit() {
        this.getLeadNotificationDetail(this.leadNoticationDetail);
    }
    getLeadNotificationDetail(leadNoticationDetail) {

        const reqData: any = {
            date: new Date(leadNoticationDetail.updated_at),
            user_id: leadNoticationDetail.target_user_id
        }
        this.leadService.getLeadNotificationDetail(reqData).subscribe(
            data => {
                this.leadNoticationDetails = data;
            }, error => {
                console.log(error);
            })
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/views/notification-detail/lead-notication-detail.ts